import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResetUserPassword } from '../../models/reset';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  login(item: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(environment.apiUrl + 'auth/superadmin/generate-code', item, {
      headers,
      withCredentials: true, // 👉 ajoute cette ligne
    }).pipe(

    );
  }


  checkValidateCode(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/superadmin/verify-pin', item).pipe(
      tap(response => {
        // Stocker le token dans le localStorage
        console.log("response.data.remember_token", response.data.remember_token);

        localStorage.setItem('access_token_ikena', response.data.remember_token);
      })
    );
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('access_token_ikena');
    return !!token && token !== 'undefined';
  }

  reset(item: any): Observable<any> {
    const requestData = {
      "email": item
    }
    return this.http.post(environment.apiUrl + `auth/reset-password`, requestData);
  }
  resetverifyEmail(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/url-verify ', item);
  }
  updatePassword(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/change-user-password ', item);
  }


  updatePasswordByReference(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `auth/change-user-password`, item);
  }
  addAdministrateur(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/superadmin/create-admin', item);
  }
  addSuperAdministrateur(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/superadmin/create-superadmin', item);
  }

  addAdministrateurToCooperative(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/admin-cooperative', item);
  }
  getAdministrateur(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/cooperative/admins/${id}`);
  }
  getLogUsers(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `auth/login-logs/${id}`);
  }

  getListVendeur(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `params/vendeurs/${id}`);
  }
  getSuperAdministrateur(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/superadmin/superadmins/${id}`);
  }

  getAllListePaiementMarketPlace(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/admin/marketplace/transactions/${id}`);
  }


    getAllListePaiementLocation(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/locations/transactions/${id}`);
  }

  getAllCommandeMarketPlace(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/admin/commandes/${id}`);
  }
  deleteAdministrateur(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/superadmin/remove-admin/${id}`, item);
  }
  deleteSuperAdministrateur(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/superadmin/remove-superadmin/${id}`, item);
  }
  changeAdministrateurStatus(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `auth/superadmin/change-admin-status`, item);
  }


  changeVendeurStatus(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `auth/superadmin/change-vendeur-status`, item);
  }
  rejeterAdministrateur(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `auth/superadmin/reject-admin`, item);
  }

  rejeterVendeur(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `auth/superadmin/reject-vendeur`, item);
  }
  updateAdministrateur(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/superadmin/update-admin', item);
  }

  updateSuperAdministrateur(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'auth/superadmin/update-superadmin', item);
  }
}
